import { SSONew } from "@/services/SSOServiceNew"
import { BACKOFFICE } from "@/services/HTTPService"
import cookie from 'js-cookie'
import store from '../store'
// import router from '../router'
import config from "@/config"

export default {
  async userInfo() {
    try {
      const response = await SSONew.get('/info')
      const data = response.data
      cookie.set('testMimkInfo', `${data.username}_${data.user_id}`)
      let role = null
      let roleField = data.groups;
      if (roleField.includes('mimk_teacher_based')) role = 'mimk'
      if (roleField.includes('mimk_supervisor')) role = 'supervisor'
      if (roleField.includes('m1')) role = 'manager'
      if (roleField.includes('is_superuser') || roleField.includes('mk_admin')) role = 'admin'
      store.commit('user/setSegmentsList', data.segments)
      store.commit('user/setUserRole', role)
      cookie.set('role', role)
      console.log(response.data)
      store.commit('user/setUserId', data.user_id)
      const fullName = `${data.last_name} ${data.first_name}`;
      store.commit('user/setFullName', fullName)
    } catch (error) {
      if (error.response.status === 401) {
        window.location.replace(`${config.MK_BACKOFFICE_URL}login/?next=${window.location.origin}`)
      }
      console.log(error.response);
    }
  },

  async getSegmentInfoAndTime() {
    try{
      const response = await BACKOFFICE.get(`/segments/${store.state.user.segment.id}/`)
      return response.data
    }catch(e) {
      console.log(e);
    }
  }
}
